import { jsx } from 'react/jsx-runtime';
import { createGlobalReferenceContext } from '@flex-packages/shared-react';
import i18n from 'i18next';

const I18nContext = createGlobalReferenceContext(
  "i18n-context",
  {
    i18n: i18n
  }
);
function I18nextProvider({ children }) {
  return /* @__PURE__ */ jsx(I18nContext.Provider, { value: { i18n: i18n }, children });
}

export { I18nContext, I18nextProvider as default };
//# sourceMappingURL=i18nNextContext.mjs.map
